import axios from 'axios'
import { createContext, ReactNode, useContext } from 'react'
import useSWR, { KeyedMutator } from 'swr'

import { LanguageContext, Locale } from '@lib/language'
import { UserCookie } from './types'

interface UserContextProps {
  user?: UserCookie
  mutateUser: KeyedMutator<UserCookie>
}

interface UserContextProviderProps {
  children: ReactNode
}

type UserKey = [string, Locale]

export const UserContext = createContext<UserContextProps>({
  mutateUser: async () => undefined,
})

export const UserContextProvider = ({ children }: UserContextProviderProps) => {
  const { locale } = useContext(LanguageContext)

  const userKey: UserKey = ['/api/auth/user', locale]
  const { data: user, mutate: mutateUser } = useSWR<UserCookie>(
    userKey,
    async ([url, locale]: UserKey) => {
      const response = await axios.get<UserCookie>(url, {
        headers: {
          'X-Locale': locale,
        },
      })

      return response.data
    },
  )

  return (
    <UserContext.Provider
      value={{
        user,
        mutateUser,
      }}
    >
      {children}
    </UserContext.Provider>
  )
}
